
import Vue from "vue";
import CatIcon from "@/components/atoms/CatIcon.vue";
import CatNicknameDialogBase from "@/components/ui/CatNicknameDialogBase.vue";
import { AssistantCat } from "@/lib/models/assistantCat";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    CatIcon,
    CatNicknameDialogBase,
  },

  props: {
    assistantCat: {
      type: Object as () => AssistantCat | null,
      default: null,
    },
    reactionMessage: {
      type: String,
      default: "",
    },
  },

  methods: {
    onOk() {
      this.$emit("ok");
    },

    onClickOutside() {
      this.onOk();
    },
  },
});

interface Data {}

interface Methods {
  onOk: () => void;
  onClickOutside: () => void;
}

interface Computed {}

interface Props {
  assistantCat: AssistantCat | null;
  reactionMessage: string;
}
